/** 위치 권한이 없거나 조회 전일 때 쓰는 기본 위치 (영등포구) */
export const DEFAULT_LOCATION = {
  longitude: 126.8962,
  latitude: 37.5264,
  region: '서울특별시',
  codeRegion: 'C01-01',
  subRegion: '영등포구',
  codeSubRegion: 'C01-01-19',
};

/**
 * 사용자 위치 기록 서비스 제공 도메인
 */
export enum GEOLOCATION_VIEW_TYPE {
  /** 동네소식에서 사용되는 지리 정보 타입 */
  HOME_TOWN_NEWS = 'HOME_TOWN_NEWS',
  /** 기타 */
  WELLO_CLIENT = 'WELLO_CLIENT',
}
